module.exports = __webpack_public_path__ + "static/img/supersound3.a7f615db.png";